export default __webpack_public_path__ + "static/media/logoutimage.71c22f77.png";